// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5386":"c7c6944b55bba871","5596":"647c18b8b117ba2e","9400":"d9157c0ea88acd64"}[chunkId] + ".css";
};